import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';

@Pipe({
  name: 'ministryCoverPhoto'
})
export class MinistryCoverPhotoPipe implements PipeTransform {
  private readonly basePath: string;
  private readonly fallbackImage: string;

  constructor() {
    this.basePath = environment.basePath || 'http://localhost:9000/';
    this.fallbackImage = '/assets/church_image.jpg';
  }

  transform(photoUrl?: string): string {
    if (!photoUrl) {
      return this.fallbackImage;
    }

    // Check if it's already a full URL (http:// or https://)
    if (/^https?:\/\//i.test(photoUrl)) {
      return photoUrl;
    }

    // Check if the URL is empty or invalid
    if (!photoUrl.trim() || photoUrl.trim() === '') {
      return this.fallbackImage;
    }

    // Prepend basePath to relative URLs
    return `${this.basePath}${photoUrl}`;
  }
}

